import { useSelector } from 'react-redux';

import { roundStatusSelector } from '../store/selectors';

/**
 * @deprecated
 * Use selector roundStatusSelector instead
 */
export function useGameStatus() {
  const gameStatus = useSelector(roundStatusSelector);

  return gameStatus;
}
